import { createListStoreWithQuery } from '@/store/list-state.factory';

export const usePhoneNumbersListStore = createListStoreWithQuery('phone-numbers-list-state');
